<template>
  <div class="download-box">
    <!-- 顶部标题 -->
    <div class="header-title">
      <img class="logo" src="../../assets/images/entryThemeOne/logo-orange.png" />
    </div>
    <h1 class="main-title">
      <img src="../../assets/images/entryThemeOne/down-money.png" alt="" />
    </h1>
    <!-- 主内容区域 -->
    <div class="main-content u-text-center">
      <!-- 成功图标 -->
      <div class="success-icon">
        <img src="../../assets/images/entryThemeOne/down-success.png" alt="" />
      </div>

      <!-- 认证成功提示 -->
      <div class="auth-success">
        <h2>恭喜您 手机号已通过认证！</h2>
        <p>前往APP领取限时福利包</p>
      </div>

      <!-- 福利卡片 -->
      <div class="benefit-cards">
        <img src="../../assets/images/entryThemeOne/down-red-envelope.png" alt="" />
      </div>

      <!-- 下载按钮 -->
      <van-button class="download-btn" type="default" @click="handleDownload">
        <van-icon name="download" size="0.32rem" />
        <span>下载APP领取额度</span>
      </van-button>
      <p class="download-tips">- 平均5秒完成下载安装 -</p>
    </div>

    <!-- 温馨提示 -->
    <div class="tips-section">
      <p class="tips-text">
        温馨提示：未经您的明示许可，本平台不会对您的个人信息进行任何处理行为。请谨防第三方短信、电话诈骗，确保您的隐私与资金安全
      </p>
    </div>

    <!-- 3步完成借款 -->
    <div class="steps-section">
      <div class="steps-title">
        <img
          class="header-line left"
          src="../../assets/images/entryThemeOne/header-line.png"
          alt=""
        />
        <!-- 合规调整：标题不再承诺审批或借款速度。 -->
        <span class="steps-title-text">申请流程</span>
        <img class="header-line" src="../../assets/images/entryThemeOne/header-line.png" alt="" />
      </div>
      <div class="steps-container">
        <div class="step-item">
          <div class="step-icon">
            <img src="../../assets/images/entryThemeOne/step_1.png" alt="" />
          </div>
          <div class="step-text">1.填写资料</div>
        </div>
        <div class="step-arrow">
          <img src="../../assets/images/entryThemeOne/step_arrow.png" alt="" />
        </div>
        <div class="step-item">
          <div class="step-icon">
            <img src="../../assets/images/entryThemeOne/step_2.png" alt="" />
          </div>
          <div class="step-text">2.申请额度</div>
        </div>
        <!-- 合规调整：移除限定时间放款承诺。 -->
      </div>
    </div>
  </div>
</template>

<script>
import * as API_Common from '@/api/common.js'

export default {
  name: 'DownloadApp',
  data() {
    return {
      channel: this.$route.query.source, // 渠道标识
      brand: this.$route.query.brand, // 设备型号
      downAppUrl: undefined, // 下载地址
    }
  },
  created() {
    window.__TRACK_SCENE_KEY__ = 'result_loan_theme'
  },
  mounted() {
    this.getDownloadUrl()
    this.trackTl5ThemeOneBase('100054')
  },
  methods: {
    // 检查是否在微信中
    isWeixin() {
      var ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    },

    // 下载按钮点击
    handleDownload() {
      this.trackTl5ThemeOneBase('100055')
      let isWeixin = this.isWeixin()
      if (isWeixin) {
        this.showPop = true
      } else {
        if (this.brand === 'xiaomi') {
          window.location.href = 'https://app.xiaomi.com/detail/1500555'
        } else {
          window.location.href = this.downAppUrl
        }
      }
    },

    // 获取下载地址
    getDownloadUrl() {
      API_Common.getDownloadUrl(this.channel).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url
        } else {
          this.$toast.fail('获取下载地址失败,请重试')
        }
      })
    },
    trackTl5ThemeOneBase(eventType) {
      API_Common.handleBatchTrackBase(eventType)
    },
  },
  beforeDestroy() {
    window.__TRACK_SCENE_KEY__ = ''
  },
}
</script>

<style lang="scss" scoped>
.download-box {
  min-height: 100vh;
  background-image: url('../../assets/images/entryThemeOne/down-bg.png');
  background-size: 100% 6rem;
  background-repeat: no-repeat;
  background-color: #f5f5f5;
  font-size: 0.24rem;
  padding: 0.1rem 0.3rem;

  // 顶部标题
  .header-title {
    padding: 0.3rem 0;

    .logo {
      width: 4rem;
      height: auto;
      margin-bottom: 0.16rem;
    }

    .title-text {
      font-size: 0.28rem;
      font-weight: 500;
      color: #333;
    }
  }

  // 主内容区域
  .main-title {
    font-size: 0.48rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.6rem;
    text-align: center;
    img {
      width: 80%;
      height: auto;
    }
    .amount {
      color: #ff5713;
    }
  }
  .main-content {
    padding: 0.5rem 0.3rem;
    background: white;
    border-radius: 0.16rem;
    box-shadow: 0 0.08rem 0.24rem rgba(0, 0, 0, 0.05);

    // 成功图标
    .success-icon {
      margin-bottom: 0.4rem;
      img {
        width: 1.4rem;
        height: auto;
      }
      .icon-circle {
        width: 1.2rem;
        height: 1.2rem;
        background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
    }

    // 认证成功提示
    .auth-success {
      margin-bottom: 0.6rem;

      h2 {
        font-size: 0.36rem;
        font-weight: 600;
        color: #333;
        margin-bottom: 0.16rem;
      }

      p {
        font-size: 0.28rem;
        color: #666;
      }
    }

    // 福利卡片
    .benefit-cards {
      display: flex;
      justify-content: center;
      margin-bottom: 0.6rem;
      img {
        width: 6rem;
        height: auto;
      }
    }

    // 下载按钮
    .download-btn {
      width: 100%;
      height: 1rem;
      background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
      border-radius: 0.5rem;
      font-size: 0.32rem;
      font-weight: 500;
      color: white;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.24rem;

      span {
        margin-left: 0.12rem;
      }
    }

    .download-tips {
      font-size: 0.24rem;
      color: #999;
    }
  }

  // 温馨提示
  .tips-section {
    padding: 0.2rem;
    margin-bottom: 0.6rem;
    background: #fffbf9;
    border-radius: 0.24rem;
    margin: 0.3rem 0;
    .tips-text {
      font-size: 0.22rem;
      color: #75280b;
      line-height: 1.5;
      text-align: left;
    }
  }

  // 流程步骤
  .process-steps {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.4rem;

    .step-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .step-icon {
        width: 0.6rem;
        height: 0.6rem;
        background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
        border-radius: 50%;
        color: white;
        font-size: 0.28rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.12rem;
      }

      .step-text {
        font-size: 0.22rem;
        color: #666;
      }
    }

    .step-arrow {
      margin: 0 0.1rem;
      color: #999;
    }
  }

  /* 3步完成借款 */
  .steps-section {
    background: linear-gradient(180deg, #fff9f6 0%, #ffffff 16.39%, #ffffff 100%);
    margin: 0.32rem 0;
    padding: 0.4rem;
    border-radius: 0.24rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .steps-title {
      font-size: 0.32rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 0.32rem;
      color: #333;
      .header-line {
        width: 1rem;
        height: 0.1rem;
        margin-bottom: 0.15rem;
        &.left {
          transform: rotate(180deg);
        }
      }
      .steps-title-text {
        margin: 0 0.2rem;
      }
    }

    .steps-container {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .step-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;

        .step-icon {
          width: 0.7rem;
          height: 0.7rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0.16rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .step-text {
          font-size: 0.2rem;
          font-weight: 600;
          color: #4b2209;
        }
      }

      .step-arrow {
        flex: 0.5;
        display: flex;
        justify-content: center;

        img {
          width: 0.7rem;
          height: 0.16rem;
          margin-bottom: 0.4rem;
        }
      }
    }
  }
}
</style>
